import dispatchEvent from "../app/util/dispatchEvent";
import {CART_UPDATED, OPEN_CART} from "../app/util/events";
const axios = require('axios');


export default () => {

    const forms = document.querySelectorAll('.js-add-product');
    for (const form of forms) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const qtyField = form.querySelector('input[name="Quantity"]');
            const qty = qtyField ? qtyField.value : 0;

            if (qty) {
                const endpoint = form.getAttribute('action');
                const formData = new FormData(form);

                axios.post(endpoint, formData, {
                    headers: {
                        'x-requested-with': 'XMLHttpRequest'
                    }
                }).then((response) => {
                    dispatchEvent(CART_UPDATED, response.data);
                    dispatchEvent(OPEN_CART);
                });
            }


            return false;
        })
    }


}
